'use strict';

var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined';
if (!isNode) {
    var requestAnimationFrame = require('requestanimationframe');
}

// Like an <img> but when src is changed the new image is crossfaded in

module.exports = React.createClass({
    propTypes: {
        opacityStep: React.PropTypes.number,
    },
    getDefaultProps: function() {
        return {
            opacityStep: 0.2,
        };
    },
    getInitialState: function() {
        return {
            stack: [{
                src: this.props.src,
                srcSet: this.props.srcSet,
                opacity: 1,
            }],
        };
    },
    componentWillReceiveProps: function(nextProps) {
        this.state.stack.push({
            src: nextProps.src,
            srcSet: nextProps.srcSet,
            opacity: 0,
        });
        requestAnimationFrame(this.tick);
    },
    tick: function() {
        // Wait until top image is complete (loaded)
        if (!this.refs.img || !ReactDOM.findDOMNode(this.refs.img).complete) {
            requestAnimationFrame(this.tick);
            return;
        }

        const top = this.state.stack[this.state.stack.length - 1];
        if (top.opacity < 1) {
            this.state.stack[this.state.stack.length - 1].opacity += this.props.opacityStep;
            requestAnimationFrame(this.tick);
        }
        else
        {
            // garbage-collect image stack 1 second after last interaction
            if (this.state.gc) {
                clearTimeout(this.state.gc);
            }
            this.state.gc = setTimeout(() => {
                this.state.stack = [ this.state.stack[this.state.stack.length - 1] ];
                this.forceUpdate();
            }, 1000);
        }
        this.forceUpdate();
    },
    render: function() {
        const stack = this.state.stack.map((cell, ix) => {
            let style = {
                opacity: cell.opacity
            };
            if (this.props.style) {
                style = Object.assign({}, style, this.props.style);
            }
            return (
                <img ref       = {ix == this.state.stack.length-1 ? 'img' : undefined}
                     key       = {'xfade-' + ix}
                     src       = {cell.src}
                     srcSet    = {cell.srcSet}
                     alt       = {this.props.alt}
                     className = {this.props.className}
                     style     = {style} />
            );
        });
        return (
            <div className='fade'>
                {stack}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/designtool/Xfade.jsx